import type { ComponentPropsWithRef } from 'react';

import { useState } from 'react';

import { clsx } from '~/styles/utils';

import { FloatingRootPortalContext } from './HeaderActions.context';
import { fabContainerStyle, headerActionsStyle } from './HeaderActions.css';

type Props = ComponentPropsWithRef<'div'>;

export const HeaderActions = ({ children, ...delegated }: Props) => {
  const [floatingRootPortal, setFloatingRootPortal] = useState<HTMLDivElement | null>(null);

  return (
    <FloatingRootPortalContext value={floatingRootPortal}>
      <div {...delegated} className={clsx(headerActionsStyle, delegated.className)}>
        {children}
      </div>

      {/* On small viewports, actions float (except tertiary ones) and action groups become a floating menu */}
      <div className={fabContainerStyle} ref={setFloatingRootPortal} />
    </FloatingRootPortalContext>
  );
};
